import React, { useState, useRef, memo } from "react";
import CreateNew from "./CreateNew";
import { VStack, Hidden } from "native-base";

const RightContent = ({
  setShowCreateNewPage,
  setType,
  setPassEntity,
  setIsShowEdit,
}) => {
  const [fixedWidth, setFixedWidth] = useState<number | undefined>(undefined);
  const rightRef = useRef<HTMLDivElement | null>(null);

  React.useLayoutEffect(() => {
    setFixedWidth((rightRef.current?.offsetWidth ?? 0) - 2);
  }, []);

  return (
    <Hidden only={["base", "sm", "md"]}>
      <VStack width={"227px"} zIndex={-1} marginLeft={"24px"} ref={rightRef}>
        <VStack position={"fixed"} space={3} width={"227px"}>
          <CreateNew
            setShowCreateNewPage={setShowCreateNewPage}
            setType={setType}
            setPassEntity={setPassEntity}
            setIsShowEdit={setIsShowEdit}
          />
        </VStack>
      </VStack>
    </Hidden>
  );
};

export default memo(RightContent);
